import {Component, OnInit, OnDestroy, Inject} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';
import {TourService} from 'ngx-tour-md-menu';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  private routerEvent: Subscription;

  url: string;
  isHome = true;
  element: HTMLElement;

  constructor(@Inject(DOCUMENT) public document: HTMLDocument,
              private router: Router,
              public tourService: TourService) {
  }

  ngOnInit(): void {
    if (this.router.url === '/') {
      this.router.navigate(['cedant']);
    }
    this.url = this.router.url;
    this.routerEvent = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // document.querySelector(
        //   '.app-inner > div'
        // ).scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
  }

  ngOnDestroy(): void {
    this.routerEvent.unsubscribe();
  }

  runOnRouteChange(): void {
    this.isHomeView();
  }

  isHomeView() {
    if ((this.router.url === '/' || this.router.url === '/cedant') || (this.router.url.indexOf('cedant') !== -1)) {
      this.isHome = true;
    } else {
      this.isHome = false;
    }
  }
}
